import React from 'react';
import { Span } from "../Base";
import Filters from './Filters';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass';
import { InlineBlock, Popover } from "reakit";
import { returnFacultyFilterString } from "../../utils";
import IosArrowUp from 'react-ionicons/lib/IosArrowUp';
import IosArrowDown from 'react-ionicons/lib/IosArrowDown';

function FilterDropdown(props) {
	const { clearFilter, history, width } = props;
	let { filters } = props;

	if (!filters.type) {
		let newfilters = {
			...filters,
			type: [],
		}

		filters = newfilters;
	}

	const newFilterTitle = title => {
		let newText = '';
		if (newText === ', ' || newText === '') {
			return title;
		} else {
			if (title === 'All Faculties') {
				return newText.substr(2);
			} else {
				return title + newText;
			}
		}
	}

	let filterTitle = returnFacultyFilterString(filters)

	let showClear = false;

	if (newFilterTitle(filterTitle) !== 'All Faculties') {
		showClear = true
	}

	const newClearFilter = () => {
		clearFilter();
	}

	return (
		<Popover.Container>
			{popover => (
				<InlineBlock relative>
					{width > 700 && (
						<Flex onClick={popover.toggle}>
							<Box><Text fontWeight={700} pt={2} color={'black'}>{newFilterTitle(filterTitle)} {showClear &&
								<Span onClick={newClearFilter} color={'blue'}>Clear</Span>}</Text></Box>
							<Box p={2}>
								{popover.visible ? <IosArrowUp  {...popover} /> :
									<IosArrowDown {...popover} />}
							</Box>
						</Flex>
					)}
					<Popover fade slide expand hideOnClickOutside {...popover} padding={0} margin={0} borderRadius={0}>
						<Filters
							{...props}
							history={history}
						/>
					</Popover>
				</InlineBlock>
			)}
		</Popover.Container>
	);
}

FilterDropdown.propTypes = {
	filter: PropTypes.string,
	width: PropTypes.string
};

FilterDropdown.defaultProps = {
	filter: 'All Faculties',
	width: 701
};

export default FilterDropdown;
